import { Component, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import { InfoFirmaVO } from "@app/shared/vo/info-firmaVO";
import { InfoCertificatoVO } from "@app/shared/vo/info-certificatoVO";
import { ProtocolloService } from "@app/shared/services/protocollo.service";
import { SlimLoadingBarService } from "ng2-slim-loading-bar";

@Component({
  selector: "app-modale-controllo-firma",
  templateUrl: "./modale-controllo-firma.component.html",
  providers: [ProtocolloService]
})
export class ModaleControlloFirmaComponent implements OnInit {
  rowsFirma = new Array<InfoFirmaVO>();
  public dataVerifica: number;
  public verificata: boolean = false;
  public nonFirmato: boolean = false;
  public loadingIndicator: boolean = false;

  @ViewChild("templateModaleControlloFirma", {static: false})
  public controlloFirmaModal: TemplateRef<any>;
  private config = {
    class: "modal-dialog modal-info modal-lg",
    animated: true
  };

  public modalRef: BsModalRef;
  inVerifica: boolean = false;
  constructor(
    private modalService: BsModalService,
    private slimLoadingBarService: SlimLoadingBarService,
    private protocolloService: ProtocolloService
  ) {}

  ngOnInit() {}

  public openModal(id: string) {
    this.nonFirmato = false;
    this.verificata = false;
    this.inVerifica = true;
    let infoFirma = new InfoFirmaVO();
    this.rowsFirma = new Array<InfoFirmaVO>();
    let infoCertificato = new InfoCertificatoVO();
    this.loadingIndicator = true;
    this.slimLoadingBarService.progress = 30;
    this.slimLoadingBarService.start();
    this.modalRef = this.modalService.show(
      this.controlloFirmaModal,
      this.config
    );
    this.protocolloService.controllaFirma(id).subscribe(
      res => {
        this.dataVerifica = res.dataVerifica;
        res.info.forEach(info => {
          infoFirma = new InfoFirmaVO();
          info.certificateInfos.forEach(certificateInfo => {
            infoCertificato = new InfoCertificatoVO();
            infoCertificato.givenName = certificateInfo.givenName;
            infoCertificato.surname = certificateInfo.surname;
            infoCertificato.notAfter = certificateInfo.notAfter;
            infoCertificato.notBefore = certificateInfo.notBefore;
            infoCertificato.caOrganization = certificateInfo.caOrganization;
            infoFirma.certificateInfos.push(infoCertificato);
          });
          infoFirma.signingTime = info.signingTime;
          infoFirma.level = info.level;
          this.rowsFirma.push(infoFirma);
        });
        this.loadingIndicator = false;
        if (res.errorCode === "999") {
          this.nonFirmato = true;
        } else {
          this.nonFirmato = false;
          if (res.statoVerifica) {
            this.verificata = true;
          } else {
            this.verificata = false;
          }
        }
        this.slimLoadingBarService.complete();
        this.inVerifica = false;
      },

      err => {
        console.log("controllaFirma err", err);
        this.slimLoadingBarService.complete();
        this.loadingIndicator = false;
      }
    );
  }
}
